import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useDispatch, useSelector } from 'react-redux'
import { TranslateContext } from '../TranslateContext'
import { selectCountryList008, selectCountryList199 } from '../../selectors'
import SupplyUnit from './supplyUnit'
import validate from 'validate.js'
import * as ActionTypes from '../../actions/actionTypes'
import { createLineItemMsgStructure } from '../../util/itemsTabValidation'

const MerchForm4 = ({ 
  lineItemIndex, 
  invoiceId,
  merchandiseId,
  saveData,
  updateData,
  isDMS,
  isImportShipment,
  invoiceIndex,
  fieldPattern,
  validateError
}) => {
  const dispatch = useDispatch()
  const UomList = useSelector((state) => state.DropDownValues?.UoM) || []
  const origin =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.origin) || ''
  const prefOrigin =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.prefOrigin) ||''
  const weightUoM =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.weightUoM) ||''
  const supplyUnit = useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.supplyUnit) || ''
  
  const translate = React.useContext(TranslateContext).translate
  const CountryList=useSelector(isImportShipment ? selectCountryList199 : selectCountryList008);

  const {lineItem} = fieldPattern()?.items

  const originErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_origin`]) 
 
  const orign=()=>{
    return(
      <DropDown
      id={`origin-${invoiceId}-${merchandiseId}`}
      label={translate('ORIGIN', { ns: ['default', 'lineItem'] })}
      className='field-bg dropdown100'
      labelClass='text-none'
      mandatory={false}
      isLabel={true}
      data={CountryList}
      value={origin}
      errors={originErr && [originErr?.msg]}
      clearable
      boxNumber={isDMS ? '5/15' : ''}
      onChange={(value) => {
        updateData({origin:value?.trim()})
        saveData({origin:value})
        const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_origin`
        validateError({[key]:""},{[key]:value},
              {[key]:lineItem(invoiceIndex+1, lineItemIndex+1)?.origin}
        )
      }}
     
    />
    )
  }
  return (
    <Grid.Row>
      {isDMS ? (
        <React.Fragment>
          <Grid.Column width='8' className='divFormFeild b-rw-0 border-bottom '>
          {orign()}
          </Grid.Column>

          <Grid.Column width='8' className='divFormFeild  border-bottom'>
          <DropDown
              id={`prefOrigin-${invoiceId}-${merchandiseId}`}
              label={translate('PREF_ORIGIN', { ns: ['default', 'lineItem'] })}
              boxNumber='5/16'
              className='field-bg dropdown100'
              labelClass='text-none'
              mandatory={false}
              isLabel={true}
              clearable
              data={CountryList}
              value={prefOrigin}
              onChange={(value) => {
                updateData({prefOrigin:value?.trim()})
                saveData({prefOrigin:value})
              }}
          
            />
          </Grid.Column>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Grid.Column width='5' className='divFormFeild b-rw-0 '>
             {orign()}
          </Grid.Column>
          <Grid.Column width='5' className='divFormFeild  b-rw-0 '>
          <SupplyUnit 
          invoiceId={invoiceId}
          invoiceIndex={invoiceIndex}
          lineItemIndex={lineItemIndex}
          updateData={updateData}
          saveData={saveData}
          translate={translate}
          weightUoM={weightUoM}
          lineItemPattern={lineItem}
          validateError={validateError}
          />
          </Grid.Column>
          <Grid.Column width='6' className='divFormFeild'>
            <DropDown
              id={`Uom-${invoiceId}-${merchandiseId}`}
              label={translate('UoM', { ns: ['default', 'lineItem'] })}
              className='field-bg dropdown100'
              labelClass='text-none'
              mandatory={false}
              isLabel={true}
              data={UomList}
              clearable
              value={weightUoM}
              onChange={(value) => {
                updateData({weightUoM:value?.trim()})
                saveData({weightUoM:value || " "})
                const key1 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_weightUoM`
                const key2 = `invoice${invoiceIndex + 1}_lineItem${lineItemIndex + 1}_supplyUnit`
                let lineItemErr = validate({ weightUoM: value?.trim(), supplyUnit: supplyUnit },
                  { weightUoM: lineItem()?.weightUoM, supplyUnit: lineItem()?.supplyUnit }
                ) || {}
                lineItemErr = createLineItemMsgStructure(lineItemErr, invoiceIndex, lineItemIndex)
                dispatch({
                  type: ActionTypes.UPDATE_VALIDATION_ERRORS,
                  tabName: 'items',
                  payload: { [key1]: "", [key2]: "", ...lineItemErr }
                })
              }}
             
            />
          </Grid.Column>
        </React.Fragment>
      )}
      
    </Grid.Row>
  )
}

export default React.memo(MerchForm4)
